import { loadStorageConfig } from '../config/storage-config-store.js';
import { createProvidersFromConfig } from '../factory/provider-factory.js';
import '../factory/built-in-registrations.js';
import { StorageRouter } from './storage-router.js';
let singleton = null;
export function getStorageRouter() {
    if (!singleton) {
        const config = loadStorageConfig();
        const providers = createProvidersFromConfig(config);
        singleton = new StorageRouter({
            providers,
            readRepair: config.readRepair,
        });
    }
    return singleton;
}
export function resetStorageRouter() {
    singleton = null;
}
//# sourceMappingURL=router-singleton.js.map